module.exports = __webpack_public_path__ + "img/34.67c28108.jpg";